import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiService, AuthService, CalendarService, ConditionService, FieldService, MetadataService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-payout-estimator',
    templateUrl: './usc-payout-estimator.component.html',
    styleUrls: ['./usc-payout-estimator.component.css']
})
export class UscPayoutEstimatorComponent implements OnInit {

    action_plan: any = {};
    daily_goal: any = {};
    payout_estimate: any = {};
    target_incentives: any;
    kicker_values: any;
    quota_postpaid_handset: any = {};
    quota_other_volume: any = {};
    quota_other_revenue: any = {};
    quota_accessory: any = {};
    quota_bir: any = {};
    quota_revenue: any = {};
    total_estimated_payout: number = 0;
    total_pacing_payout: number = 0;
    total_estimated_payout_2: number = 0;
    total_pacing_payout_2: number = 0;
    days_remaining: number = 0;
    public is_retail_corp: boolean = false;
    public is_action_plan_loaded: boolean = false;
	public plan_month: string = "Jan";
	public plan_year: string = "2022";
    portalReadySub:Subscription;
    dlgUpdateEstimates: NgbModalRef = null;
    // debugging
    isDev:boolean = true;
    testing: any = null; 
    // {
    //     postpaid: { mtd:0 },
    //     other_volume: { mtd:0 },
    //     revenue: { mtd:0 },
    //     upgrades: { mtd:0 },
    //     high_msrp_accessories: { mtd:0 }
    // };

    // new payout estimator 2.0
    business_drivers: any[] = [];
    current_oei_quota_pct: any = null;
    current_cei_quota_pct: any = null;
    forecast_business_drivers: any[] = [];
    // filtered_business_drivers: any[] = [];
    business_drivers_loaded: boolean = false;
    public visibleColumnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    public columnFields: Array<any> = [];
    public view: string = this.uscStoreService.view_p2w_payout_estimator;
    public curPage: number = 1;
    public pageSize: number = 15;
    public pageCount: number = 0;
    public itemCount: number = 0;

    drivers: any[] = [
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "postpaid", label: "Postpaid", driver_type: "postpaid_handset_volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "other_volume", label: "Other Volume", driver_type: "other_volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "revenue", label: "Revenue", driver_type: "revenue" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "upgrades", label: "Upgrades", driver_type: "upgrades" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "high_msrp_accessories", label: "High MSRP Accessories", driver_type: "high_msrp_accessories" },
    ];

    constructor(
		public uscStoreService: UscStoreService,
		public apiService: ApiService,
        public authService: AuthService,
        public translatorService: TranslatorService,
        public calendarService: CalendarService,
        public metadataService: MetadataService,
        public conditionService: ConditionService,
        public fieldService: FieldService,
        public sessionService: SessionService,
		public ngbModal: NgbModal,
        ) { 

            this.portalReadySub = this.uscStoreService.portalReady.subscribe(ready => {
                if (ready && this.is_action_plan_loaded) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_payout_estimator);
            });
        }

    ngOnInit() {
        this.is_retail_corp = this.uscStoreService.isUSCellCorp();
        this.uscStoreService.getThisMonthActionPlans().subscribe(
            result => {
                this.action_plan = result;
                let date = new Date();
                this.plan_month = this.calendarService.getAbbrMonthName(date.getMonth());
                var year = date.getFullYear();
                this.plan_year = year.toString();
                this.loadPayoutEstimatorV2();
                // if (this.is_retail_corp) {
                //     this.loadPayoutEstimatorV2();
                // } else {
                //     this.loadPayoutEstimatorV1();
                // }
            }
        );
    }

    loadPayoutEstimatorV2() {
        if (this.uscStoreService.isStoreMgrOrAssistant() || this.uscStoreService.isTelesalesManager()) this.action_plan = { cs_days_scheduled: "N/A", days_worked: "N/A" };
        else if (!this.uscStoreService.isActionPlanRequired() && this.action_plan == null) this.action_plan = { cs_days_scheduled: "N/A", days_worked: "N/A" };
        this.loadTableViewMetaData();
    }

    loadPayoutEstimatorV1() {
        // this month's action plan has not been approved
        if (this.action_plan == null || this.action_plan.cs_status == this.uscStoreService.action_plan_status_draft) {
            this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
        } else {
            this.is_action_plan_loaded = true;
            // get Payout
            this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked - 1;
            this.uscStoreService.getThisMonthPayoutEstimate(this.drivers, this.action_plan, this.days_remaining, this.testing).subscribe(
                result => {
                    this.drivers = result.drivers;
                    this.payout_estimate = result.payout_estimate;
                    this.total_estimated_payout = result.total_estimated_payout;
                    this.total_pacing_payout = result.total_pacing_payout;
                    this.target_incentives = result.target_incentives;
                    this.kicker_values = result.kicker_values;
                }
            )
        }
    }

    getTargetIncentive(driver) {
        var user = this.authService.getActive();
        var incentive = this.target_incentives[driver].find(i => i.title == user.title);
        return incentive;
    }

    getKickerValue(driver) {
        var user = this.authService.getActive();
        var kicker = this.kicker_values[driver].find(i => i.title == user.title);
        return kicker;
    }

    getFormattedDriverValue(driver, column, value) {
        if (value == null) value = 0;
        var value_formats = [
            // percentage
            { driver: "postpaid", column: "mtd_quota_pct", format_type: "percentage" },
            { driver: "other_volume", column: "mtd_quota_pct", format_type: "percentage" },
            { driver: "revenue", column: "mtd_quota_pct", format_type: "percentage" },
            { driver: "revenue", column: "kicker_value", format_type: "percentage" },
            // number
            { driver: "postpaid", column: "mtd", format_type: "number" },
            { driver: "other_volume", column: "mtd", format_type: "number" },
            { driver: "upgrades", column: "mtd", format_type: "number" },
            { driver: "high_msrp_accessories", column: "mtd", format_type: "number" },
            { driver: "postpaid", column: "quota", format_type: "number" },
            { driver: "other_volume", column: "quota", format_type: "number" },
            // blank
            { driver: "upgrades", column: "quota", format_type: "blank" },
            { driver: "upgrades", column: "mtd_quota_pct", format_type: "blank" },
            { driver: "upgrades", column: "incentive", format_type: "blank" },
            { driver: "upgrades", column: "incentive_earned", format_type: "blank" },
            { driver: "high_msrp_accessories", column: "quota", format_type: "blank" },
            { driver: "high_msrp_accessories", column: "mtd_quota_pct", format_type: "blank" },
            { driver: "high_msrp_accessories", column: "incentive", format_type: "blank" },
            { driver: "high_msrp_accessories", column: "incentive_earned", format_type: "blank" },
        ]

        var format = value_formats.find(b => b.driver == driver && b.column == column);
        if (format == null) format = { driver: "", column: "", format_type: "currency" };
        var formatted_value = "";
        switch (format.format_type) {
            case "blank": formatted_value = ""; break;
            case "percentage": formatted_value = this.translatorService.toPercentage(value); break;
            case "currency": formatted_value = this.translatorService.toCurrency(value, 2); break;
            case "number": formatted_value = value; break;
        }
        return formatted_value;
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
		const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
		modalRef.componentInstance.parentView = this.uscStoreService.view_p2w_payout_estimator_table;
		modalRef.componentInstance.data = item;
		modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
		modalRef.componentInstance.msg_config = msg_config;
		return modalRef;
	}

    onFocusOut(driver, field) {
        if (driver[field.key] == '' || driver[field.key] == null) driver[field.key] = 0;
        var data = { "quota_month": this.uscStoreService.getThisMonthActionPlanSubject(), "user_ID": this.authService.getActive().ID };
        if (driver.name == 'oei' && this.current_oei_quota_pct != null && this.current_oei_quota_pct != driver[field.key]) {
            data[driver.business_driver] = driver[field.key];
            this.dlgUpdateEstimates = this.showCustomPromptDlg({}, { msg: "Updating Payout Estimate..." });
            this.apiService.processCaseAction("update_payout_estimator", data, "raw").subscribe(
                pe => {
                    this.reloadItems();
                    console.log('update_payout_estimator succeed', pe);
                },
                err => {
                    console.log('update_payout_estimator failed', err);
                    this.sessionService.log("unable to get timeslots");
                }
            )
        } else if (driver.name == 'cei' && this.current_cei_quota_pct != null && this.current_cei_quota_pct != driver[field.key]) {
            data[driver.business_driver] = driver[field.key];
            this.dlgUpdateEstimates = this.showCustomPromptDlg({}, { msg: "Updating Payout Estimate..." });
            this.apiService.processCaseAction("update_payout_estimator", data, "raw").subscribe(
                pe => {
                    this.reloadItems();
                    console.log('update_payout_estimator succeed', pe);
                },
                err => {
                    console.log('update_payout_estimator failed', err);
                    this.sessionService.log("unable to get timeslots");
                }
            )
        }
    }

    stringify(item): string {
        return JSON.stringify(item);
    }

    getUserIncentive() {
        if (this.target_incentives) {
            var user_incentive = {
                postpaid: this.getTargetIncentive("postpaid"),
                other_volume: this.getTargetIncentive("other_volume"),
                revenue: this.getTargetIncentive("revenue"),
                upgrades: this.getTargetIncentive("upgrades"),
                high_msrp_accessories: this.getTargetIncentive("high_msrp_accessories"),
            }
            return user_incentive;
        }
        return "";
    }

    getUserKickerValue() {
        if (this.kicker_values) {
            var user_kicker_value = {
                postpaid: this.getKickerValue("postpaid"),
                other_volume: this.getKickerValue("other_volume"),
                revenue: this.getKickerValue("revenue"),
                upgrades: this.getKickerValue("upgrades"),
                high_msrp_accessories: this.getKickerValue("high_msrp_accessories"),
            }
            return user_kicker_value;
        }
        return "";
    }

    getBusinessDriverDesc(field) {
		return this.uscStoreService.getBusinessDriverDesc(field);
	}

    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }



    //#region Payout Estimator 2.0
    loadTableViewMetaData() {
        this.business_drivers_loaded = false;
        this.visibleColumnFields = [];
        this.columnFields = [];
        this.metadataService.getTableViewMetaData(this.uscStoreService.view_p2w_payout_estimator_table, {}, true).subscribe(result => {
            this.columnFields = result.meta_data.column_fields;
            this.viewConditions = result.meta_data.view_conditions;
            this.reloadItems();
        });
    }

    reloadItems() {
        var params = {
            est: 'ST_Search'
        }
		let dlg = null;
        this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_table, params).subscribe(
            result => {
                this.business_drivers = result.items;
                var oei = this.business_drivers.find(d => d.name == "oei");
                if (oei) this.current_oei_quota_pct = oei.quota_pct;
                var cei = this.business_drivers.find(d => d.name == "cei");
                if (cei) this.current_cei_quota_pct = cei.quota_pct;
                this.processDetailedItems();
                this.total_estimated_payout_2 = 0;
                this.business_drivers.forEach(bd => {
                    this.total_estimated_payout_2 += bd.estimated_payout;
                })
                this.is_action_plan_loaded = true;
                if (this.dlgUpdateEstimates != null) {
                    this.dlgUpdateEstimates.dismiss();
                    this.dlgUpdateEstimates = null;
                } 
            },
            err => {
                console.log(err);
            }
        );
        
        this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_forecast_table, params).subscribe(
            result => {
                this.forecast_business_drivers = result.items;
                this.total_pacing_payout_2 = 0;
                this.forecast_business_drivers.forEach(bd => {
                    this.total_pacing_payout_2 += bd.estimated_payout;
                })        
            },
            err => {
                console.log(err);
            }
        );    
    }

    processDetailedItems() {
        // this.filtered_business_drivers = this.business_drivers;
        this.business_drivers_loaded = true;

        this.business_drivers.forEach(bd => {
            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                bd.viewConditions = this.conditionService.evaluateItemValues(conditions, null, bd);
            }
        });

        // extract all visible columns
        this.visibleColumnFields = [];
        this.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible) {
                    var condResult = this.conditionService.getCondition(this.business_drivers[0].viewConditions, cf.sn_column_visible);
                    bVisible = condResult ? condResult.result : true;
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }
        })
        this.itemCount = this.business_drivers.length;
        this.pageCount = 1;

        //this.generateFilterData();
    }

    // generateFilterData() {
    //     this.columnFields.forEach(f => {
    //         if (f.enable_filtering) f.filter_data = this.getDataFilter(f);
    //     })
    // }

    // getDataFilter(field) {
    //     var filter_list = [{ label: 'All', value: '' }];
    //     if (this.business_drivers_loaded && field.enable_filtering) {
    //         if (field.filter_data_source == 'data') {
    //             this.filtered_business_drivers.forEach(bd => {
    //                 var field_value = this.getFieldValue(bd, field);
    //                 var filter = filter_list.find(f => f.value == field_value);
    //                 if (filter == null) {
    //                     filter_list.push({ label: field_value, value: field_value });
    //                 }
    //             })
    //         }
    //         filter_list.sort(function (a, b) {
    //             if (a.value < b.value) return -1;
    //         })
    //     }
    //     return filter_list;
    // }

    getFieldValueStyle(bd_item, field) {
        var fvc = {};
        if (bd_item && field) {
            var field_value = bd_item[field.key];
            var bd_conditions = bd_item.viewConditions;
            var is_main_business_driver = bd_item.viewConditions.find(c => c.name == "is_main_business_driver");
            switch (field.key) {
                case "business_driver": 
                    if (is_main_business_driver.result) fvc = { "font-weight": "bold" };
                    break;
                case "quota_pct":
                case "contribution":
                    var is_contribution_limit_not_reached = bd_item.viewConditions.find(c => c.name == "is_contribution_limit_not_reached");
                    fvc = is_contribution_limit_not_reached.result ? { "font-weight": "bold", "color": "red" } : { "font-weight": "bold", "color": "#0068CA" };
                    if (field_value == null) fvc = { "background-color": "#2f75b5" };
                    break;
                case "target_incentive_quota_pct":
                    var is_target_incentive_limit_not_reached = bd_item.viewConditions.find(c => c.name == "is_target_incentive_limit_not_reached");
                    fvc = is_target_incentive_limit_not_reached.result ? { "font-weight": "bold", "color": "red" } : { "font-weight": "bold", "color": "#0068CA" };
                    if (field_value == null) fvc = { "background-color": "#2f75b5" };
                    break;
                default:
                    if (is_main_business_driver.result) fvc = { "font-weight": "bold", "color": "#0068CA" };
                    // null field_value
                    if (field_value == null) fvc = { "background-color": "#2f75b5" };
                    break;
            }
        }
        return fvc;
    }

    showFilteredValue(field): boolean {
        return (field && field.current_filtered_value);
    }

    getFilteredValue(field) {
        return field.current_filtered_value;
    }

    getColumnLabel(field): any {
        if (field) {
            var column_label = field.label;
            switch (column_label) {
                case "MTD Pacing to Quota": column_label = "Sales vs Quota"; break;
                case "MTD Pacing to P2W Goal": column_label = "Sales vs P2W Goal"; break;
                case "MTD": column_label = "Actual Sales"; break;
                case "MTD Upgrade": column_label = "Actual Upgrade"; break;
                case "MTD High MSRP Accessories": column_label = "Actual High MSRP Accessories"; break;
            }
            return column_label;
        }
        return "";
    }

    getFieldValue(bd_item, field): any {
        if (bd_item && field) {
            var bd = bd_item["business_driver"];
            var is_total_gross_adds = bd_item.viewConditions.find(c => c.name == "is_total_gross_adds");
            var is_total_upgrades = bd_item.viewConditions.find(c => c.name == "is_total_upgrades");
            var is_revenue = bd_item.viewConditions.find(c => c.name == "is_revenue");
            var is_oei = bd_item.viewConditions.find(c => c.name == "is_oei");
            var is_cei = bd_item.viewConditions.find(c => c.name == "is_cei");
            var field_value = bd_item[field.key];
            if (field_value || (field_value == 0 && (is_total_gross_adds.result || is_total_upgrades.result || is_revenue.result || (is_oei && is_oei.result) || (is_cei && is_cei.result)))) {
                switch (field.key) {
                    case "contribution":
                    case "weighted_value": 
                    case "over_performance": 
                    case "estimated_payout": 
                        if (field_value >= 0) field_value = field_value.toFixed(2);
                        if (field_value >= 0 && field.key == "estimated_payout") field_value = this.translatorService.toCurrency(field_value, 2);
                        break;
                    default:
                        if (field.key.indexOf('pct') >= 0) field_value = this.translatorService.toPercentage(field_value);
                        else if (field.key != 'business_driver' && bd.indexOf('$') >= 0) field_value = this.translatorService.toCurrency(field_value, 2);
                        else if (field.key != 'business_driver' && bd.indexOf('Spiff') >= 0) field_value = this.translatorService.toCurrency(field_value, 2);
                        else if (field_value >= 0 && field.key.indexOf('incentive') >= 0) field_value = this.translatorService.toCurrency(field_value, 2);
                        break;
                }
            }
            return field_value != null ? field_value : '';
        }
        return null;
    }
    
    isValueVisible(action_plan, field) {
        return true;
    }

    isFieldEditable(bd_item, field) {
        var is_oei = bd_item.viewConditions.find(c => c.name == "is_oei");
        if (is_oei && is_oei.result && field.key == "quota_pct") return true;

        var is_cei = bd_item.viewConditions.find(c => c.name == "is_cei");
        if (is_cei && is_cei.result && field.key == "quota_pct") return true;
        return false;
    }

    public showBusinessDriverToolTip(bd_item, field) {
        if (field.key == "business_driver") return this.uscStoreService.getBusinessDriverDesc(bd_item.name) != null;
        return false;
	}

	public getBusinessDriverToolTip(bd_item, field) {
		if (field.key == "business_driver") return this.uscStoreService.getBusinessDriverDesc(bd_item.name);
        return false;
	}

    isImageIcon(btn) { return (btn.button_type == "IMG"); }
    //#endregion
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-payout-estimator/usc-payout-estimator.component.ts